import type { NoteKeyValue } from 'features/Procedure/state/procedure-api.type'

export const normalizeKeyValueEntries = (input: unknown): NoteKeyValue[] => {
  if (!input || typeof input !== 'object' || Array.isArray(input)) {
    return []
  }

  return Object.entries(input as Record<string, unknown>)
    .filter(
      ([key, value]) =>
        key.trim().length > 0 && typeof value === 'string' && value.trim().length > 0,
    )
    .map(([key, value]) => ({ key, value: value as string }))
}

const TEMPLATE_ENTRY_SEPARATOR = '\n\n\n'

export const formatNotesSeed = (notes: NoteKeyValue[]): string =>
  notes.map((note) => `${note.value}:`).join(TEMPLATE_ENTRY_SEPARATOR)

export const resolveSectionSeed = (sectionValue: string | null, notes: NoteKeyValue[]): string => {
  if (sectionValue !== null) {
    return sectionValue
  }
  return formatNotesSeed(notes)
}

const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max)

export type CaretInsertResult = {
  value: string
  cursor: number
}

export const insertTextAtCursor = (
  value: string,
  selectionStart: number,
  selectionEnd: number,
  insertText: string,
  separator = ' ',
): CaretInsertResult => {
  const safeStart = clamp(selectionStart, 0, value.length)
  const safeEnd = clamp(selectionEnd, safeStart, value.length)
  const before = value.slice(0, safeStart)
  const after = value.slice(safeEnd)
  const needsLeadingSeparator = before.length > 0 && !/\s$/.test(before)
  const prefix = needsLeadingSeparator ? separator : ''
  const nextValue = `${before}${prefix}${insertText}${after}`
  const cursor = before.length + prefix.length + insertText.length

  return { value: nextValue, cursor }
}
